import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalAddAttachment.vue?vue&type=template&id=4540e8dd&"
import script from "./AssessmentGlobalSingleTaskModalAddAttachment.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalAddAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports